import { IOfferwallCase, IOfferwallRecordPayload } from '../../../services/gmoOfferwallApi';
import yup from '../../../utils/types/helpText';

export const DEFAULT_URL =
  'https://liff.line.me/2003648082-5XBdjEQE/landing?follow=%40644ivprr&lp=AwbhUo&liff_id=2003648082-5XBdjEQE';

export type OfferwallFormValues = {
  url: string;
  icon_url: string;
  title: string;
  requirements: string;
  point: string;
  stages: string;
  bonus_point: string;
  notes: string;
  title_internal: string;
  clid: string;
  type: string;
  sort: string;
  category: string;
  is_visible: boolean;
  has_bonus_type: boolean;
};

const nullableNumberField = (label: string) =>
  yup
    .number()
    .transform((_, value) => (value === '' || value === null ? null : Number(value)))
    .typeError(`${label}は数値で入力してください`)
    .nullable();

export const offerwallValidation = yup.object().shape({
  url: yup.string().required('URLは必須です'),
  icon_url: yup.string().nullable(),
  title: yup.string().required('タイトルは必須です'),
  requirements: yup.string().nullable(),
  point: yup.string().nullable(),
  stages: yup.string().nullable(),
  bonus_point: nullableNumberField('bonus_point'),
  notes: yup.string().nullable(),
  title_internal: yup.string().nullable(),
  clid: yup.string().nullable(),
  type: yup.string().nullable(),
  sort: nullableNumberField('sort'),
  category: yup.string().nullable(),
  is_visible: yup.boolean().required(),
  has_bonus_type: yup.boolean().required(),
});

export const createOfferwallDefaultValues = (): OfferwallFormValues => ({
  url: DEFAULT_URL,
  icon_url: '',
  title: '',
  requirements: '',
  point: '',
  stages: '',
  bonus_point: '',
  notes: '',
  title_internal: '',
  clid: '',
  type: '',
  sort: '',
  category: '',
  is_visible: true,
  has_bonus_type: false,
});

export const createOfferwallEditValues = (
  record: IOfferwallCase | null,
): OfferwallFormValues => ({
  url: record?.url || DEFAULT_URL,
  icon_url: record?.icon_url || '',
  title: record?.title || '',
  requirements: record?.requirements || '',
  point: record?.point || '',
  stages: record?.stages || '',
  bonus_point:
    record?.bonus_point === null || record?.bonus_point === undefined
      ? ''
      : String(record.bonus_point),
  notes: record?.notes || '',
  title_internal: record?.title_internal || '',
  clid: record?.clid || '',
  type: record?.type || '',
  sort: record?.sort === null || record?.sort === undefined ? '' : String(record.sort),
  category: record?.category || '',
  is_visible: !record?.deleted_at,
  has_bonus_type: record?.bonus_type === 1,
});

const toNullableString = (value?: string | null) => {
  const trimmed = value?.trim() || '';
  return trimmed === '' ? null : trimmed;
};

const toNullableNumber = (value?: string | null) => {
  const trimmed = value?.trim() || '';
  if (trimmed === '') {
    return null;
  }

  const parsed = Number(trimmed);
  return Number.isNaN(parsed) ? null : parsed;
};

const formatCurrentTime = () => {
  const now = new Date();
  const pad = (num: number) => String(num).padStart(2, '0');

  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(
    now.getHours(),
  )}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
};

export const buildOfferwallPayload = (
  values: OfferwallFormValues,
): IOfferwallRecordPayload => ({
  url: values.url.trim(),
  icon_url: values.icon_url.trim(),
  title: values.title.trim(),
  requirements: values.requirements.trim(),
  point: toNullableString(values.point),
  deleted_at: values.is_visible ? null : formatCurrentTime(),
  stages: toNullableString(values.stages),
  bonus_point: toNullableNumber(values.bonus_point),
  notes: toNullableString(values.notes),
  title_internal: toNullableString(values.title_internal),
  clid: toNullableString(values.clid),
  type: toNullableString(values.type),
  sort: toNullableNumber(values.sort),
  bonus_type: values.has_bonus_type ? 1 : null,
  category: toNullableString(values.category),
});
